export default "__VITE_ASSET__CHSUOaXv__"